export default __webpack_public_path__ + "static/media/no-video.65ff3352.png";